// Code generated by Prismic. DO NOT EDIT.

import Advertisement from './Advertisement';

export const components = {
  advertisement: Advertisement,
};
